import React from 'react';

/**
 * CamposRecordatorios — Fase 22 · #21: hasta 2 recordatorios por email a quien no haya reservado,
 * N días laborables antes de la fecha límite. Vacío = null = no enviar.
 *
 * Rediseño (Fase 2): sacado de Paso3Fechas sin cambiar su comportamiento, para que Editar lo ponga
 * en «Reglas». El asistente lo sigue viendo dentro de Paso3Fechas.
 * `compacto`: sin el título y la explicación largos (Editar los pone en la cabecera de la sección).
 */
export default function CamposRecordatorios({ payload, dispatch, compacto = false }) {
  const setCampo = (campo, valor) => dispatch({ type: 'SET_FIELD', field: campo, value: valor });
  const r1 = payload.recordatorio_1_dias_lab_antes;
  const r2 = payload.recordatorio_2_dias_lab_antes;

  return (
    <div>
      {!compacto && (
        <>
          <h4 className="text-sm font-semibold text-slate-900 mb-1">
            Recordatorios automáticos a usuarios sin cita
          </h4>
          <p className="text-xs text-slate-500 mb-3">
            Enviar hasta 2 recordatorios por email a los usuarios que no hayan reservado antes
            de la fecha límite. Deja vacío para no enviar.
          </p>
        </>
      )}
      <div className="grid grid-cols-2 gap-3 max-w-md">
        <RecordatorioInput
          label="1er recordatorio"
          value={r1}
          onChange={(v) => setCampo('recordatorio_1_dias_lab_antes', v)}
        />
        <RecordatorioInput
          label="2º recordatorio"
          value={r2}
          onChange={(v) => setCampo('recordatorio_2_dias_lab_antes', v)}
        />
      </div>
      {compacto && (
        <p className="text-xs text-slate-400 mt-1">
          Por email, a quien no haya reservado. Vacío = no se envía.
        </p>
      )}
      {r1 != null && r2 != null && r2 >= r1 && (
        <p className="text-[11px] text-amber-700 mt-2">
          ⚠ El 2º recordatorio se enviará antes o el mismo día que el 1º. Normalmente el 2º
          debería tener menos días (más cerca de la fecha límite).
        </p>
      )}
    </div>
  );
}

// Input numérico de días laborables (vacío = null = no enviar).
function RecordatorioInput({ label, value, onChange }) {
  return (
    <div>
      <label className="block text-xs font-medium text-slate-700 mb-1">{label}</label>
      <div className="flex items-center gap-2">
        <input
          type="number"
          min={0}
          max={60}
          value={value ?? ''}
          onChange={(e) => {
            const raw = e.target.value.trim();
            if (raw === '') { onChange(null); return; }
            const n = parseInt(raw, 10);
            if (!Number.isFinite(n)) { onChange(null); return; }
            onChange(Math.max(0, Math.min(60, n)));
          }}
          placeholder="—"
          aria-label={label}
          className="w-16 border border-slate-200 rounded-md px-2 py-1 text-sm"
        />
        <span className="text-xs text-slate-500">días laborables antes</span>
      </div>
    </div>
  );
}
